import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LoaderState } from './loader.interface';

@Injectable()
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();

  private pendingLoaderRequests = 0;

  loaderState = this.loaderSubject.asObservable();

  constructor() {}

  show() {
    this.pendingLoaderRequests++;
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  hide() {
    this.pendingLoaderRequests--;
    if (this.pendingLoaderRequests <= 0) {
      this.loaderSubject.next(<LoaderState>{ show: false });
    }
  }
}
